import { buildModelManager } from "../builder.js";
const DefaultShopifyCustomerAddressSelection = {
  __typename: true,
  id: true,
  address1: true,
  address2: true,
  city: true,
  company: true,
  coordinatesValidated: true,
  country: true,
  countryCode: true,
  countryCodeBackup: true,
  countryName: true,
  createdAt: true,
  firstName: true,
  formatted: true,
  formattedArea: true,
  lastName: true,
  latitude: true,
  longitude: true,
  name: true,
  phone: true,
  province: true,
  provinceCode: true,
  shopId: true,
  shopifyCustomerId: true,
  timezone: true,
  updatedAt: true,
  validationResultSummary: true,
  zipCode: true
};
const modelApiIdentifier = "shopifyCustomerAddress";
const pluralModelApiIdentifier = "shopifyCustomerAddresses";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyCustomerAddressSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyCustomerAddressSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCustomerAddressSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCustomerAddressSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCustomerAddressSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCustomerAddressSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCustomerAddressSelection,
    namespace: null
  }
];
operations.push(...[
  "create",
  "bulkCreate",
  "update",
  "bulkUpdate",
  "delete",
  "bulkDelete"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyCustomerAddress does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyCustomerAddressManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyCustomerAddressSelection,
  operations
);
export {
  DefaultShopifyCustomerAddressSelection,
  ShopifyCustomerAddressManager
};
//# sourceMappingURL=ShopifyCustomerAddress.js.map
